export const BP_SMALL = 'small'
export const BP_MEDIUM = 'medium'
export const BP_LARGE = 'large'
export const BP_XLARGE = 'xlarge'
export const BP_XXLARGE = 'xxlarge'
export const BP_XXXLARGE = 'xxxlarge'
export const BP_OVERRIDE = '__OVERRIDE__'
export const BP_MEDIUM_MAX = 'medium_max'
export const BP_LARGE_MAX = 'large_max'
export const BP_XLARGE_MAX = 'xlarge_max'
export const BP_XXLARGE_MAX = 'xxlarge_max'
export const BP_XXXLARGE_MAX = 'xxxlarge_max'
